import { Controller } from '@hotwired/stimulus'
import './marquee_component.scss'

export default class extends Controller {
  static values = { hideUntilLoaded: Boolean }
  static classes = ['loading']
  connect() {
    if (this.hideUntilLoadedValue) {
      this.element.classList.remove(this.loadingClass)
    }
  }
}
